import React, { useState } from 'react';
import { FileEdit, PlayCircle } from 'lucide-react';

interface ReportFormProps {
  onSubmit: (taskId: string, docId: string | null, pageId: string | null) => Promise<void>;
  onExampleClick: () => void;
  loading: boolean;
  defaultApiKey: string;
  onApiKeyChange: (apiKey: string) => void;
}

export const ReportForm: React.FC<ReportFormProps> = ({
  onSubmit,
  onExampleClick,
  loading,
  defaultApiKey,
  onApiKeyChange
}) => {
  const [taskId, setTaskId] = useState('');
  const [pageId, setPageId] = useState('');
  const [hasDocument, setHasDocument] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    onApiKeyChange(defaultApiKey);
    await onSubmit(
      taskId,
      hasDocument ? '2vuwu-45207' : null,
      hasDocument ? pageId : null
    );
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label htmlFor="taskId" className="block text-sm font-medium text-gray-700 mb-1">
          ID da Tarefa
        </label>
        <input
          type="text"
          id="taskId"
          value={taskId}
          onChange={(e) => setTaskId(e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
          placeholder="Ex: 86a32n2dr"
          required
        />
      </div>

      <div className="space-y-2">
        <div className="flex items-center">
          <input
            type="checkbox"
            id="hasDocument"
            checked={hasDocument}
            onChange={(e) => setHasDocument(e.target.checked)}
            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
          />
          <label htmlFor="hasDocument" className="ml-2 block text-sm text-gray-700">
            Incluir documento
          </label>
        </div>

        {hasDocument && (
          <div>
            <label htmlFor="pageId" className="block text-sm font-medium text-gray-700 mb-1">
              ID da Página do Documento
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <FileEdit className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="text"
                id="pageId"
                value={pageId}
                onChange={(e) => setPageId(e.target.value)}
                className="w-full pl-10 px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                placeholder="Ex: 2vuwu-253713"
                required={hasDocument}
              />
            </div>
          </div>
        )}
      </div>

      <div className="space-y-2">
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50"
        >
          {loading ? 'Gerando relatório...' : 'Gerar Relatório'}
        </button>

        <button
          type="button"
          onClick={onExampleClick}
          className="w-full text-gray-600 py-2 px-4 rounded-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 flex items-center justify-center gap-2 text-sm"
        >
          <PlayCircle className="w-4 h-4" />
          Gerar relatório de exemplo
        </button>
      </div>
    </form>
  );
};